import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Dashboard from "./pages/Dashboard";
import Orders from "./pages/Orders";
import Users from "./pages/Users";
import Products from "./pages/Products";
import OtcProducts from "./pages/OtcProducts";
import Billing from "./pages/Billing";
import Chat from "./pages/Chat";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import Sidebar from "./components/Sidebar";
import Header from "./components/Header";
import AppFooter from "./components/AppFooter";
import ToastNotifications from "./components/ToastNotifications";
import ConfirmationModal from "./components/ConfirmationModal";
import Notifications from "./pages/Notifications";
import AllNotifications from "./pages/AllNotifications";
import Settings from "./pages/Settings";
import KupatHolimSettings from "./pages/KupatHolimSettings";
import ChangePassword from "./pages/ChangePassword";
import { PrivacyPolicy, Support, TermsAndConditions } from "./pages/Legal";
import AccountDeletion from "./pages/AccountDeletion";
import { hasValidAuthSession } from "./services/authService";

// Layout (Sidebar + Header)
const MainLayout = ({ children }) => {
  return (
    <>
      <Sidebar />
      <Header />
      {children}
      <AppFooter />
      <ToastNotifications />
    </>
  );
};

const ProtectedRoute = ({ children }) => {
  if (!hasValidAuthSession()) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

function App() {
  return (
    <BrowserRouter>
      <ConfirmationModal />
      <Routes>
        {/* Default → Login */}
        <Route path="/" element={<Navigate to="/login" />} />

        {/* Login Page */}
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/privacy" element={<Navigate to="/privacy-policy" replace />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/terms" element={<Navigate to="/terms-and-conditions" replace />} />
        <Route path="/support" element={<Support />} />
        <Route path="/account-deletion" element={<AccountDeletion />} />

        {/* All Pages with Layout */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Dashboard />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/archives"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Orders />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route path="/orders" element={<Navigate to="/archives" replace />} />
        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Users />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/products"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Products />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/products/new"
          element={<ProtectedRoute><MainLayout><Products /></MainLayout></ProtectedRoute>}
        />
        <Route
          path="/products/:id/edit"
          element={<ProtectedRoute><MainLayout><Products /></MainLayout></ProtectedRoute>}
        />
        <Route
          path="/otc"
          element={<ProtectedRoute><MainLayout><OtcProducts /></MainLayout></ProtectedRoute>}
        />
        <Route
          path="/otc/new"
          element={<ProtectedRoute><MainLayout><OtcProducts /></MainLayout></ProtectedRoute>}
        />
        <Route
          path="/otc/:id/edit"
          element={<ProtectedRoute><MainLayout><OtcProducts /></MainLayout></ProtectedRoute>}
        />
        <Route
          path="/billing"
          element={<ProtectedRoute><MainLayout><Billing /></MainLayout></ProtectedRoute>}
        />
        <Route path="/driver-deliveries" element={<Navigate to="/users" replace />} />
        <Route path="/change-password" element={<ProtectedRoute><MainLayout><ChangePassword /></MainLayout></ProtectedRoute>} />
        <Route
          path="/chat"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Chat />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/pharmacist-recommendation"
          element={
            <ProtectedRoute>
              <Navigate to="/products" replace />
            </ProtectedRoute>
          }
        />
        <Route
          path="/notifications"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Notifications />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/all-notifications"
          element={
            <ProtectedRoute>
              <MainLayout>
                <AllNotifications />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Navigate to="/settings/categories" replace />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings/categories"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Settings />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings/kupat-holims"
          element={<ProtectedRoute><MainLayout><KupatHolimSettings /></MainLayout></ProtectedRoute>}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
